import { ApplicationRootState } from 'store/types';

const selectTime = (state: ApplicationRootState) => state.time;

export default selectTime;
